import React from "react"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"

const SssList = (props) => {

  return (
    <Page padding={false}>
      <Panel hasFooter={false} noHeader id={props.id} className="ssslist">
        <Element type="h2">Bilmem gereken başka neler var?</Element>
        <List
          accordion
          accordionCollapsible
          activeItem={0}
          className=""
          custom={false}
          disabled={false}
          expandOnlyOne
          withPadding
          withoutBorder={false}
        >
          <List.Item
            accordion={false}
            accordionCollapsible
            disabled={false}
            preventDefault
            title="Kredi hesaplaması nasıl yapılır?"
            withPadding={false}
          >
           Talep ettiğin kredi tutarı ve vadeyi girerek, sana uygun faiz oranını ve aylık taksit tutarını görüntüleyebilirsin. Ayrıca kredi ile birlikte ödeyeceğin diğer masrafları ve toplam maliyetini de görüntülersin. Kredi tutarı ve vaden, satın alacağın aracın tutarına göre değişebilmektedir.
            <br /><br />
           Faiz oranı, girdiğin tutar ve vadeye göre, sigortalı olmasına, aracın 0 km ve 2. el olmasına göre değişebilir.

          </List.Item>
          <List.Item
            accordion={false}
            accordionCollapsible
            disabled={false}
            preventDefault
            title="Kimler Taşıt Kredisi kullanabilir?"
            withPadding={false}
          >
            18 yaşından büyük olunmalı, risk ve istihbaratta olumsuzluk olmamalıdır. Gelir belgelenmelidir. Kredinin taksiti, hane halkı aylık ortalama gelirinin %50’sini geçmemelidir.
          </List.Item>
          <List.Item
            accordion={false}
            accordionCollapsible
            disabled={false}
            preventDefault
            title="Satın alacağım taşıtın ne kadarlık tutarı için Taşıt Kredisi kullanabilirim?"
            withPadding={false}
          >
            0 km taşıt kredileri için nihai fatura değeri; 2.el taşıtlar için ise kasko değeri:
            <List className="sss-inner-list">
              <List.Item>0 - 400.000 TL aralığında olan araçlar için azami %70’i, </List.Item>
              <List.Item>400.001 - 800.000 TL aralığında olan araçlar için azami %50’si, </List.Item>
              <List.Item>800.001 - 1.200.000 TL aralığında olan araçlar için azami %30’u, </List.Item>
              <List.Item>1.200.001 - 2.000.000 TL aralığında olan araçlar için azami %20’si kadar taşıt kredisi kullandırılabilmektedir. </List.Item>
            </List>

          </List.Item>
          <List.Item
            accordion={false}
            accordionCollapsible
            disabled={false}
            preventDefault
            title="Kaç ay vadeye kadar kredi kullanabilirim? "
            withPadding={false}
          >
            0 km taşıt kredileri için nihai fatura değeri; 2.el taşıtlar için ise kasko değeri:
            <List className="sss-inner-list">
              <List.Item>0 - 400.000 TL aralığında olan araçlar için azami 48 ay,</List.Item>
              <List.Item>400.001 - 800.000 TL aralığında olan araçlar için azami 36 ay,</List.Item>
              <List.Item>800.001 - 1.200.000 TL aralığında olan araçlar için azami 24 ay,</List.Item>
              <List.Item>1.200.001 - 2.000.000 TL aralığında olan araçlar için azami 12 aya kadar taşıt kredisi kullandırılabilmektedir.</List.Item>
            </List>
          </List.Item>
          <List.Item
            accordion={false}
            accordionCollapsible
            disabled={false}
            preventDefault
            title="Kredimi nasıl kullanabilirim?"
            withPadding={false}
          >
            En yakın Akbank şubesi ve ya anlaşmalı olduğumuz taşıt bayilerinden kullanabilirsiniz.
          </List.Item>
          <List.Item
            accordion={false}
            accordionCollapsible
            disabled={false}
            preventDefault
            title="Trafik Sigortası ve Kasko zorunluluğu var mı?"
            withPadding={false}
          >
           Kredi kullandırımında Trafik Sigortası yaptırımı yasal olarak zorunludur. Kaskonuzu Bankamızdan yaptırabileceğiniz gibi, dilerseniz başka bir sigorta şirketinden de “dain-i mürtehin” Akbank olacak şekilde yaptırabilirsiniz.
          </List.Item>
          <List.Item
            accordion={false}
            accordionCollapsible
            disabled={false}
            preventDefault
            title="2. el taşıt kredisiyle kaç yıllık araç alınabilir?"
            withPadding={false}
          >
            İkinci el araçlar için araç yaş sınırı 10’dur. Kredi vadesi ile araç yaşının toplamı en fazla 12 yıl olabilmektedir.
          </List.Item>
        </List>
      </Panel>
    </Page>
  )
}

export default SssList
